module.exports = __webpack_public_path__ + "static/babyacc1-4d64a7000c074707bf5403c5118db4d8.jpeg";